import { Star } from "lucide-react";

function DailyInfo({ event }: any) {
    return (
        <div className="tw-flex tw-items-center tw-gap-1.5 tw-rounded-md tw-border tw-border-amber-300 tw-bg-amber-50 tw-px-2 tw-py-1 tw-text-sm tw-text-amber-900 tw-w-full tw-mb-1">
            <Star size={10} className="tw-shrink-0 tw-fill-amber-400 tw-text-amber-400" />
            <span className="tw-truncate">{event.name}</span>
        </div>
    );
}

export default DailyInfo;
